import React from 'react'
import { Drawer, Box } from '@mui/material'
import { PersonListTab } from './PersonListTab.js'

const ListDetailModal = ({
  isOpen,
  onClose,
  user,
  handleAddToListClick,
  handleAddToCampaignClick,
  isConfirmingLeads
}) => {
  return (
    <Drawer
      anchor='right'
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '600px',
          maxWidth: '600px',
          height: '90%',
          marginTop: '40px',
          borderRadius: '16px',
          boxShadow: '-26px -22px 9px -12px #E1E3EC'
        }
      }}
      ModalProps={{
        keepMounted: true,
        BackdropProps: {
          sx: {
            background: 'none'
          }
        }
      }}
    >
      <Box sx={{ padding: '15px 20px 0px 20px' }}>
        <Box
          sx={{
            display: 'flex',
            borderBottom: '1px solid #E5E7EB',
            backgroundColor: '#E1E3EC',
            borderRadius: '8px',
            overflow: 'hidden',
            marginBottom: '16px'
          }}
        >
          <Box
            sx={{
              flex: 1,
              textAlign: 'center',
              padding: '8px 0',
              fontWeight: 'bold',
              color: '#111827',
              backgroundColor: '#FFFFFF',
              margin: '6px',
              borderRadius: '8px',
              fontSize: '14px',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
            }}
          >
            Person
          </Box>
        </Box>
      </Box>
      <PersonListTab
        user={user}
        handleAddToListClick={handleAddToListClick}
        handleAddToCampaignClick={handleAddToCampaignClick}
        isConfirmingLeads={isConfirmingLeads}
      />
    </Drawer>
  )
}

export default ListDetailModal
